<app-header></app-header>
<div class="container margin-top-70">
  <div class="container">
    <div class="row">
      <div class="col-md-6 mt-8">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>User Id</td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="selectStatusTypeDropDownOptions"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'userId'"
                ></app-drop-down-single-select>
              </td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="selectedUserId"
                  name="userId"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="container table-responsive">
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button
        type="submit"
        class="btn btn-primary btn-pkt"
        (click)="searchProduct()"
      >
        Search
        <i class="bi bi-search ps-1"></i>
      </button>
      <button
        type="submit"
        class="btn btn-primary btn-pkt"
        (click)="downloadReport()"
      >
        Download
        <i class="bi bi-download ps-1"></i>
      </button>
    </div>
  </div>

  <div class="container">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" style="width: 15%;">Product ID</th>
          <th scope="col" style="width: 10%;">First Name</th>

          <th scope="col" style="width: 10%;">Title</th>
          <th scope="col" style="width: 20%;">Chapter Number</th>

          <th scope="col" style="width: 20%;">Chapter Name</th>
          <th scope="col" style="width: 15%;">FD Received Date</th>
          <th scope="col" style="width: 15%;">Revised FD Received</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let product of products">
          <tr *ngFor="let chapter of product.chapter">
            <td>{{product.part_number }}</td>
            <td>
              {{product?.assigned_user?.first_name }}
              {{product?.assigned_user?.last_name }}
            </td>
            <td>{{product.name }}</td>
            <td>{{chapter.chapter_number }}</td>
            <td>{{chapter.name }}</td>
            <td>{{chapter.fd_received_date }}</td>
            <td>{{chapter.revised_fd_received }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="container">
    <app-pagination
      [maxSize]="maxSize"
      [pageSize]="pageSize"
      [collectionSize]="totalProducts"
      (pageChanged)="updatePageData($event)"
    ></app-pagination>
  </div>
</div>
